import React from 'react'

class NotStartedBadge extends React.Component {
  render() {
    return (
      <svg className="notStartedBadge" width="24" height="24" viewBox="0 0 24 24">
        <path
          fill="none"
          fillRule="nonzero"
          stroke="#CCC"
          strokeWidth="1.8"
          d="M16.422 22.676l1.396-4.858 4.858-1.396L20.228 12l2.448-4.422-4.858-1.396-1.396-4.858L12 3.772 7.578 1.324 6.182 6.182 1.324 7.578 3.772 12l-2.448 4.422 4.858 1.396 1.396 4.858L12 20.228l4.422 2.448z"
        />
      </svg>
    )
  }
}

export default NotStartedBadge
